var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('h1',[_vm._v("Fotos")]),_c('p',[_vm._v("Text")]),_vm._v(" "+_vm._s(_vm.tasks)+" "),_c('div',{staticClass:"gantt-target"}),_c('b-form-input',{model:{value:(_vm.tasks[0].start),callback:function ($$v) {_vm.$set(_vm.tasks[0], "start", $$v)},expression:"tasks[0].start"}}),_c('b-card')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }